// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3671":"2e21dced","8018":"00831513"}[chunkId] + ".chunk.css";
};